import { SUPPORT_PROCESS_CODES, type ProcessCodeType } from '@/constants/processCodes';

type UserLike =
  | {
      id?: number;
      isAspiceSpecialist?: boolean;
    }
  | null
  | undefined;

type ProjectLike =
  | {
      managers?: { id: number }[];
    }
  | null
  | undefined;

type ProcessLike =
  | {
      processCode?: string;
      owner?: { id: number } | null;
      owners?: Array<{ id: number } | null | undefined>;
    }
  | null
  | undefined;

export function isAspiceSpecialist(user: UserLike): boolean {
  return Boolean(user?.isAspiceSpecialist);
}

export function canManageProject(user: UserLike, project: ProjectLike): boolean {
  if (isAspiceSpecialist(user)) {
    return true;
  }
  if (!user?.id || !project?.managers) {
    return false;
  }
  return project.managers.some((manager) => manager.id === user.id);
}

export function canOperateAsProcessOwner(user: UserLike, process: ProcessLike): boolean {
  if (isAspiceSpecialist(user)) {
    return true;
  }
  return Boolean(user?.id && process?.owner?.id === user.id);
}

export function canEditProcessDocs(
  user: UserLike,
  processes: ProcessLike[],
  processCode: string,
  options?: { categoryCode?: string; currentMainTab?: string },
): boolean {
  if (isAspiceSpecialist(user)) {
    return true;
  }

  const currentProcess = processes.find((process) => process?.processCode === processCode);

  // if (options?.currentMainTab === 'qa' || options?.categoryCode === 'QA') {
  //   const supProcess = processes.find((process) => process?.processCode === 'SUP.1');
  //   return supProcess?.owner?.id === user?.id || false;
  // }

  if (options?.currentMainTab === 'traceability') {
    return currentProcess?.owner?.id === user?.id || false;
  }

  // if (SUPPORT_PROCESS_CODES.includes(processCode as ProcessCodeType)) {
  //   return user?.id === currentProcess?.owner?.id || false;
  // }

  return (
    [...(currentProcess?.owners || []), currentProcess?.owner].some(
      (owner) => owner?.id === user?.id,
    ) || false
  );
}

/** 质量保证三个页签的写操作：专员，或 SUP.1 负责人 / 成员。 */
export function canOperateQualityAssurance(user: UserLike, processes: ProcessLike[]): boolean {
  if (isAspiceSpecialist(user)) {
    return true;
  }
  const supProcess = processes.find((process) => process?.processCode === 'SUP.1');
  if (!user?.id || !supProcess) {
    return false;
  }
  return [...(supProcess.owners || []), supProcess.owner].some((person) => person?.id === user.id);
}

export function canOperateDocument(
  user: UserLike,
  documentInfo?: { isOwner?: boolean; isMember?: boolean } | null,
): boolean {
  if (isAspiceSpecialist(user)) {
    return true;
  }
  return Boolean(documentInfo?.isOwner || documentInfo?.isMember);
}
